var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-12 mb-4"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('img',{staticClass:"thumb",attrs:{"src":_vm.thumb}})]),_c('div',{staticClass:"col-md-8"},[_c('h3',[_c('a',{attrs:{"href":_vm.url}},[_vm._v(_vm._s(_vm.title))])]),_c('p',[_vm._v(_vm._s(_vm.desc))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }